/*
 * Bootstrap Cookie Alert by Wruczek
 * https://github.com/Wruczek/Bootstrap-Cookie-Alert
 * Released under MIT license
 *
 * A little bit altered by Elmar Höfinghoff and Georg Schwagereit
 *
 */
(function () {
    "use strict";

    // check component exists
    var cookieAlert = document.querySelector(".ca-cookiealert");
    if (!cookieAlert) {
       return;
    }

    // get component elements
    var denyCookies = document.querySelector(".ca-denycookies");
    var acceptCookies = document.querySelector(".ca-acceptcookies");
    var kitCookieAlert = document.querySelector(".kit-cookie-alert");
    var rte_a = document.querySelectorAll(".kit-cookie-alert__rte a");

    // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)
    cookieAlert.offsetHeight;

    // apply rte element classes
    for (var i = 0; i < rte_a.length; ++i) {
        rte_a[i].classList.add("text-light");
        rte_a[i].classList.add("ca-underline");
    }

    // Show the alert if we cant find the "CMSCookieLevel" cookie
    if (!getCookie("CMSCookieLevel") || getCookie("CMSCookieLevel") === "-100") {
        setCookie("CMSCookieLevel", -100, 365);
        cookieAlert.classList.add("ca-show");

        // raise body padding-bottom to mind content overlay
        kitCookieAlert.style.cssText = "padding-bottom: " + cookieAlert.clientHeight + "px";
    }

    // When clicking on the agree button, create a 1 year
    // cookie to remember user's choice and close the banner
    acceptCookies.addEventListener("click", function () {
        setCookie("CMSCookieLevel", 1000, 365);
        cookieAlert.classList.remove("ca-show");
        kitCookieAlert.style.removeProperty("padding-bottom");

        // Reload page to re-run GTM initialization
        location.reload();
    });

    // When clicking on the deny button
    denyCookies.addEventListener("click", function () {
        setCookie("CMSCookieLevel", 0, 365);
        cookieAlert.classList.remove("ca-show");
        kitCookieAlert.style.removeProperty("padding-bottom");

        // Reload page to re-run GTM initialization
        location.reload();
    });

    // Cookie function from w3schools
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    // Cookie function from w3schools
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
})();
